import { resolveCDNDir } from '@gjensidige/se-content-helpers';

const baseCDNUrl: string = resolveCDNDir();

const API_ENDPOINTS = {
  demoURL: '/offer_gfseext/car/demo',
  getEligibilityURL: () => `/offer_gfseext/eligibility`,
  getTemplateURL: () => `/offer_gfseext/product/template`,
  getMetaDataURl: () => `/offer_gfseext/product/purchase/template`,
  getAllOffersURL: (policyNumber: string) =>
    `/offer_gfseext/revoke/${policyNumber}`,
  getOfferURL: (policyNumber: string) => `/offer_gfseext/offer/${policyNumber}`,
  getSavedOfferURL: (policyNumber: string) => `/offer_gfseext/savedOffer/${policyNumber}`,
  getOfferSummaryURL: (policyNumber: string) =>
    `/offer_gfseext/offerSummary/${policyNumber}`,
  getSavedOfferSummaryURL: (policyNumber: string) =>
    `/offer_gfseext/summary/${policyNumber}`,
  getTextURL: (product: string) => `/offer_gfseext/${product}/template`,
  createOfferURL: `/offer_gfseext/create`,
  updateOfferURL: `/offer_gfseext/update`,
  saveOfferURL: `/offer_gfseext/save`,
  saveAndSendOfferURL: `/offer_gfseext/saveOfferEmail`,
  getCachedCreateOfferURL: (product: string, policynumber: number) =>
    `/offer_gfseext/${product}/${policynumber}`,
  getAppTextUrl: () => `${baseCDNUrl}texts/app-webshop-se.json`,
  getProductConfigUrl: (product: string, channel: string) => {
    if (channel?.toLowerCase() === 'niemi') {
      return `${baseCDNUrl}maps/webshop-se/${product}/package-configurations-niemi.json`
    }
    return `${baseCDNUrl}maps/webshop-se/${product}/package-configurations.json`
  },
  getQuestionsConfigUrl: (product: string, channel: string) => {
    if (channel?.toLowerCase() === 'hgf') {
      return `${baseCDNUrl}maps/webshop-se/${product}/question-configurations-hgf.json`;
    }
    if (product === 'car') {
      return `${baseCDNUrl}maps/webshop-se/${product}/question-configurations-unified.json`;
    }
    return `${baseCDNUrl}maps/webshop-se/${product}/question-configurations.json`;
  },
  getProductDocumentsUrl: `/product-documents/documents/product-code/`,
  getLoggedInStatusUrl: `/api-tools/v1/open/auth-level`
};

export default API_ENDPOINTS;
